'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100px;\n  height: 100px;\n  margin: 10px;\n  border-radius: 10px;\n'], ['\n  width: 100px;\n  height: 100px;\n  margin: 10px;\n  border-radius: 10px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  color: ', ';\n'], ['\n  color: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _color = require('./../color');

var _color2 = _interopRequireDefault(_color);

var _color3 = require('../color');

var _color4 = _interopRequireDefault(_color3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Circle = _styledComponents2.default.div(_templateObject);

var Label = _styledComponents2.default.p(_templateObject2, _color4.default.grey_main);

var MozartColor = function MozartColor(props) {
  var color = props.color,
      themeId = props.themeId;

  return _react2.default.createElement(
    'div',
    { 'data-theme': themeId },
    _react2.default.createElement(Circle, { style: _color2.default[color] && _color2.default[color].includes('linear') ? { background: _color2.default[color] } : { backgroundColor: _color2.default[color] } }),
    _react2.default.createElement(
      Label,
      null,
      color
    )
  );
};

MozartColor.propTypes = {
  color: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string
};

MozartColor.defaultProps = {
  color: '',
  themeId: 'MozartColor'
};

exports.default = MozartColor;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartColor/MozartColor.js
// module id = 1834
// module chunks = 1